import React from 'react';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { IStoredDevice } from '@store/Devices.store';

interface IDevice
    extends Pick<IStoredDevice, 'imei' | 'name'>,
        Partial<Omit<IStoredDevice, 'imei' | 'name'>> {}

interface IProps {
    devices: IDevice[];
    visible: boolean;
}

const Component: React.FC<IProps> = ({ devices, visible }: IProps) => {
    let expandIcon = <ExpandMore sx={{ color: 'transparent' }} />;
    //if (devices.length > 0) {
        expandIcon = visible ? (
            <ExpandMore className="groups__item-expand-icon_up" />
        ) : (
            <ExpandMore className="groups__item-expand-icon_down" />
        );
    //}

    return <>{expandIcon}</>;
};

const ExpandIconComponent = React.memo(Component);

export default ExpandIconComponent;
